export default {
	name: 'API Keys',
	slug: 'api-keys',
	icon: 'key',
	description: 'Manage external API access tokens',
	isCustom: true,
	hide: false
}
